import  { useState, useEffect, useRef } from "react";
import { Table, Input, Button, Space, Spin, Modal, Form } from "antd";
import { message } from "../../components/antdMessageBridge";
import {  CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import CommonObj from "../../CommonObj";
import { useNavigate } from "react-router-dom";
import { getUTCDate } from "../../components/utcDate";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import { useAuth } from "../../auth/AuthContext";
import RejectSlide from "./reject-slide";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./clientqueue-slider.css";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import { renderCommonPaginationTotal } from "../../components/commonpagination/common-pagination";
import "../../components/commonpagination/common-pagination.css";

const Clientqueue = () => {
	const navigate = useNavigate();
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [startTime, setStartTime] = useState("");
	const [sortedInfo, setSortedInfo] = useState({});
	const [searchFilters, setsearchFilters] = useState({});
	const { accessToken } = useAuthToken();
	const { roleUserId } = useAuth();
	const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 })
	const [activeScanner, setActiveScanner] = useState(null);
	const [decodedResults, setDecodedResults] = useState([]);
	const [rackId, setRackId] = useState([])
	const searchInput = useRef(null);

	const [isModalVisible, setIsModalVisible] = useState(false);
	const [isModalBoxVisible, setIsModalBoxVisible] = useState(false);
	const [selectedRecord, setSelectedRecord] = useState(null);
	const [rejectionOptions, setRejectOptions] = useState([]);
	const [isDisabled, setIsDisabled] = useState(false);
	const [form] = Form.useForm();

	const handleCancel = () => {
		setIsModalVisible(false);
		setIsModalBoxVisible(false);
		setSelectedRecord(null);
		form.resetFields();
	};

	const fetchRejectionData = async () => {

		setLoading(true);
		try {
			const myHeaders = {
				"Authorization": `Bearer ${accessToken}`,
				"X-CSRF-Token": encryptTimestamp(),
				"Content-Type": "application/json",
			};
			const response = await fetch(CommonObj.Endpoints.GetClientRejectionTypes, {
				method: 'POST',
				headers: myHeaders,
			});

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const result = await response.json();
			const books = Array.isArray(result) ? result : [result];
			const formattedData = books.map(item => ({
				...item,
				key: item.referenceId,
			}));
			setRejectOptions(formattedData);
		} catch (err) {
			setError(err);
		} finally {
			setLoading(false);
		}
	};

	const handleClientQueueReject = async (key) => {
		const commaSeparatedIds = selectedRowKeys.join(',');
		let bids;
		// Show a loading message while the API call is in progress
		if (commaSeparatedIds) {
			bids = commaSeparatedIds;
		}
		else {
			bids = selectedRecord.bidNo;
		}
		try {
			const loadingKey = 'rejecting';
			message.loading({ content: 'Reworking BID...', key: loadingKey });
			const endUTCTime = getUTCDate();
			const payload = {

				biDs: bids,
				userId: roleUserId,
				startTime: startTime,
				endTime: endUTCTime?.UTCDate,
				rejectionType: key.rejectionType,
				rejectionReason: key.rejectionReason,
				rackShelf: key.rackAndShelf
			};

			const myHeaders = {
				"Authorization": `Bearer ${accessToken}`,
				"X-CSRF-Token": encryptTimestamp(),
				'Content-Type': 'application/json'
			};

			// Replace with your actual API call using axios
			const response = await fetch(CommonObj.Endpoints.ClientQueueReject, {
				method: 'POST',
				headers: myHeaders,
				body: JSON.stringify(payload),
			});

			if (response) {
				fetchData({ pagination, sorter: sortedInfo, filters: searchFilters });
				const startUTCTime = getUTCDate();
				setStartTime(startUTCTime?.UTCDate);
				message.success({ content: 'Book(s) has been sent for rework successfully!', key: loadingKey, duration: 2 });
				handleCancel();
				setSelectedRowKeys();
			} else {
				message.error({ content: 'Failed to Rework BID.', key: loadingKey, duration: 2 });
			}
		} catch (error) {
			console.error('API Error:', error);
			message.error({ content: 'An error occurred. Please try again.', key: 'rejecting', duration: 2 });
		}
	};

	const showRejectModal = (record) => {
				setRackId(record?.rackShelf)

		fetchRejectionData();
		setSelectedRecord(record.bid);
		setSelectedRowKeys([record.bid]);
		setIsModalVisible(true);
	};

	const handleReset = (dataIndex, clearFilters) => {
		clearFilters();
		setsearchFilters((prev) => {
			const updated = { ...prev };
			delete updated[dataIndex];
			return updated;
		})
		fetchData({ pagination, sorter: sortedInfo, filters: { ...searchFilters, [dataIndex]: undefined } })
	};

	const getColumnSearchProps = (dataIndex) => ({
		filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
			<div style={{ padding: 8 }}>
				<Input
					ref={searchInput}
					placeholder={`Search ${dataIndex}`}
					value={selectedKeys[0]}
					onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}

					style={{ marginBottom: 8, display: "block" }}
					onPressEnter={() => confirm()}

				/>
				<Space>
					<Button type="primary" size="small" onClick={() => confirm()}>Search</Button>
					<Button size="small" onClick={() => {
						handleReset(dataIndex, clearFilters);
						confirm(); // Explicitly call confirm to refresh the table
					}}>Reset</Button>

				</Space>
			</div>
		),
		filterIcon: (filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />),
		filteredValue: searchFilters[dataIndex] ? [searchFilters[dataIndex]] : null,
		onFilter: (value, record) => record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
		onFilterDropdownOpenChange: (visible) => {
			if (visible) {
				setTimeout(() => searchInput.current.select(), 100);
			}
		},
		sorter: true,
		sortOrder: sortedInfo.columnKey === dataIndex ? sortedInfo.order : null
	});

		const rackRender = (record)=>{
		
		return record
	}
	
    const handleEdit = (key, string) => {

        navigate("/self-fixed", { state: { key, string } });
    };

	const columns = [
		{
			title: "BID No",
			dataIndex: "bid",
			key: "bid",
			width: 160,
			sorter: (a, b) => a.bid.localeCompare(b.bid),
			...getColumnSearchProps("bid"),

		},
		{
			title: "ISBN",
			dataIndex: "isbn",
			key: "isbn",
			width: 200,
			sorter: (a, b) => a.isbn.localeCompare(b.isbn),
			...getColumnSearchProps("isbn"),
		},
		{
			title: "Title",
			dataIndex: "title",
			key: "title",
			width: 220,
			sorter: (a, b) => a.title.localeCompare(b.title),
			...getColumnSearchProps("title"),
			render:(text)=>(<div style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>{text}</div>)

		},
		{
			title: "Author",
			dataIndex: "author",
			key: "author",
			width: 220,
			sorter: (a, b) => a.author.localeCompare(b.author),
			...getColumnSearchProps("author"),
		},
		{
			title: "Publisher",
			dataIndex: "publisher",
			key: "publisher",
			width: 220,
			sorter: (a, b) => a.publisher.localeCompare(b.publisher),
			...getColumnSearchProps("publisher"),
		},
		{
			title: "Language",
			dataIndex: "language",
			key: "language",
			width: 160,
			sorter: (a, b) => a.language.localeCompare(b.language),
			...getColumnSearchProps("language"),

		},
		{
			title: "Book Type",
			dataIndex: "bookType",
			key: "bookType",
			width: 200,
			filters: [
				{ text: "Hardcover", value: "Hardcover" },
				{ text: "Paperback", value: "Paperback" },
				{ text: "eBook", value: "eBook" },
			],
			onFilter: (value, record) => record.format === value,
			sorter: (a, b) => a.format.localeCompare(b.format),
			...getColumnSearchProps("bookType"),
		},
		{
			title: "Condition",
			dataIndex: "condition",
			key: "condition",
			width: 120,
			...getColumnSearchProps("condition"),
		},
		{
			title: "Wear Level",
			dataIndex: "wearLevel",
			key: "wearLevel",
			width: 200,
			...getColumnSearchProps("wearLevel"),
		},
		{
			title: "Binding",
			dataIndex: "binding",
			key: "binding",
			width: 120,
			...getColumnSearchProps("binding"),
		},
		{
			title: "Content",
			dataIndex: "content",
			key: "content",
			width: 220,
			...getColumnSearchProps("content"),
		},
		{
			title: "Rack Shelf",
			dataIndex: "rackShelf",
			key: "rackShelf",
			width: 220,
			render: (text)=><div>{rackRender(text)}</div>,
			...getColumnSearchProps("rackShelf"),
		},
		{
			title: "Updated Page Count",
			dataIndex: "updatedPageCount",
			key: "updatedPageCount",
			width: 230,
			...getColumnSearchProps("updatedPageCount"),
		},
		{
			title: "Client Rejection Reason",
			dataIndex: "clientRejectComments",
			key: "clientRejectComments",
			width: 230,
			...getColumnSearchProps("clientRejectComments"),
			render:(text)=>(<div style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>{text}</div>)
		},
		{
			title: "Upload Date",
			dataIndex: "uploadDate",
			key: "uploadDate",
			width: 230,
			...getColumnSearchProps("uploadDate"),
			render:(text)=>(<div style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>{text}</div>)
		},
		{
			title: "Actions",
			key: "actions",
			width: 100,
			align: "center",
			render: (_, record) => (
				<div >
				<Space size="middle" title="Rework">
						<button type="button" onClick={() => showRejectModal(record)}>
							<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_5244_39974)">
									<path d="M5.53317 8.72222H4.93317V8.72222L5.53317 8.72222ZM5.53317 9.41667L5.08399 9.81445C5.19222 9.93667 5.34557 10.0095 5.50868 10.0162C5.6718 10.0228 5.83058 9.96274 5.94842 9.84976L5.53317 9.41667ZM7.16524 8.6831C7.40444 8.45376 7.41243 8.07395 7.1831 7.83476C6.95376 7.59556 6.57395 7.58757 6.33476 7.8169L6.75 8.25L7.16524 8.6831ZM4.94918 7.85221C4.72949 7.60414 4.35029 7.58113 4.10221 7.80082C3.85414 8.02051 3.83113 8.39971 4.05082 8.64779L4.5 8.25L4.94918 7.85221ZM11.1712 6.78244C11.3963 7.02569 11.7759 7.04047 12.0191 6.81544C12.2624 6.59042 12.2771 6.21081 12.0521 5.96756L11.6117 6.375L11.1712 6.78244ZM9.03278 5.25V4.65C6.77308 4.65 4.93317 6.46876 4.93317 8.72222H5.53317H6.13317C6.13317 7.14037 7.42692 5.85 9.03278 5.85V5.25ZM5.53317 8.72222L4.93317 8.72222L4.93317 9.41667H5.53317H6.13317L6.13317 8.72222L5.53317 8.72222ZM5.53317 9.41667L5.94842 9.84976L7.16524 8.6831L6.75 8.25L6.33476 7.8169L5.11793 8.98357L5.53317 9.41667ZM5.53317 9.41667L5.98236 9.01888L4.94918 7.85221L4.5 8.25L4.05082 8.64779L5.08399 9.81445L5.53317 9.41667ZM11.6117 6.375L12.0521 5.96756C11.3031 5.15782 10.2267 4.65 9.03278 4.65V5.25V5.85C9.88006 5.85 10.6409 6.20913 11.1712 6.78244L11.6117 6.375Z" fill="#002449" />
									<path d="M12.4641 8.58301L12.9126 8.18451C12.8043 8.06252 12.6509 7.98994 12.4878 7.98348C12.3248 7.97702 12.1662 8.03724 12.0485 8.15026L12.4641 8.58301ZM10.8344 9.31628C10.5954 9.54581 10.5877 9.92564 10.8173 10.1646C11.0468 10.4036 11.4266 10.4113 11.6656 10.1818L11.25 9.74902L10.8344 9.31628ZM13.0515 10.1475C13.2715 10.3953 13.6508 10.4177 13.8985 10.1976C14.1462 9.97749 14.1686 9.59825 13.9485 9.35052L13.5 9.74902L13.0515 10.1475ZM6.8125 11.2276C6.58574 10.986 6.20603 10.974 5.9644 11.2007C5.72278 11.4275 5.71073 11.8072 5.9375 12.0488L6.375 11.6382L6.8125 11.2276ZM8.9511 12.7497V13.3497C11.216 13.3497 13.0641 11.5331 13.0641 9.27745H12.4641H11.8641C11.8641 10.8572 10.5665 12.1497 8.9511 12.1497V12.7497ZM12.4641 9.27745H13.0641V8.58301H12.4641H11.8641V9.27745H12.4641ZM12.4641 8.58301L12.0485 8.15026L10.8344 9.31628L11.25 9.74902L11.6656 10.1818L12.8797 9.01575L12.4641 8.58301ZM12.4641 8.58301L12.0155 8.98151L13.0515 10.1475L13.5 9.74902L13.9485 9.35052L12.9126 8.18451L12.4641 8.58301ZM6.375 11.6382L5.9375 12.0488C6.68857 12.8491 7.76191 13.3497 8.9511 13.3497V12.7497V12.1497C8.10468 12.1497 7.3446 11.7946 6.8125 11.2276L6.375 11.6382Z" fill="#002449" />
									<circle opacity="0.5" cx="9" cy="9" r="7.5" stroke="#002449" stroke-width="1.2" />
								</g>
								<defs>
									<clipPath id="clip0_5244_39974">
										<rect width="18" height="18" fill="white" />
									</clipPath>
								</defs>
							</svg>

						</button>

				</Space>
								<Space size="middle" style={{marginLeft:"20px"}}  title="Self Fix">
					<button type="button"  onClick={() => handleEdit(record.bid, 'client')}>
<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="9" cy="4.5" r="3" stroke="#002449" stroke-width="1.2"/>
<path opacity="0.5" d="M11.25 9.99533C10.5552 9.83712 9.79568 9.75 9 9.75C5.68629 9.75 3 11.261 3 13.125C3 14.989 3 16.5 9 16.5C13.2656 16.5 14.4986 15.7363 14.8551 14.625" stroke="#002449" stroke-width="1.2"/>
<rect x="9" y="9" width="8.25" height="8.25" rx="4.125" fill="white"/>
<g clip-path="url(#clip0_5244_39975)">
<circle cx="14" cy="13" r="1" stroke="#002449"/>
<path d="M14.5867 9.71774C14.4641 9.66699 14.3088 9.66699 13.9982 9.66699C13.6876 9.66699 13.5323 9.66699 13.4098 9.71774C13.2464 9.7854 13.1166 9.91518 13.049 10.0785C13.0181 10.1531 13.006 10.2398 13.0012 10.3663C12.9943 10.5522 12.899 10.7243 12.7379 10.8173C12.5768 10.9103 12.3801 10.9068 12.2156 10.8199C12.1037 10.7608 12.0225 10.7279 11.9425 10.7173C11.7672 10.6943 11.5899 10.7418 11.4497 10.8494C11.3445 10.9301 11.2668 11.0646 11.1115 11.3336C10.9562 11.6026 10.8785 11.7372 10.8612 11.8686C10.8381 12.0439 10.8856 12.2212 10.9933 12.3615C11.0424 12.4255 11.1114 12.4793 11.2186 12.5467C11.3761 12.6457 11.4775 12.8143 11.4775 13.0003C11.4775 13.1864 11.3761 13.355 11.2186 13.4539C11.1114 13.5213 11.0424 13.5751 10.9932 13.6391C10.8856 13.7794 10.8381 13.9567 10.8612 14.132C10.8785 14.2635 10.9561 14.398 11.1115 14.667C11.2668 14.936 11.3444 15.0705 11.4496 15.1512C11.5899 15.2589 11.7672 15.3064 11.9425 15.2833C12.0225 15.2728 12.1036 15.2399 12.2156 15.1807C12.38 15.0938 12.5767 15.0903 12.7378 15.1833C12.899 15.2764 12.9943 15.4484 13.0012 15.6343C13.006 15.7608 13.0181 15.8475 13.049 15.9221C13.1166 16.0855 13.2464 16.2152 13.4098 16.2829C13.5323 16.3337 13.6876 16.3337 13.9982 16.3337C14.3088 16.3337 14.4641 16.3337 14.5867 16.2829C14.75 16.2152 14.8798 16.0855 14.9475 15.9221C14.9783 15.8475 14.9904 15.7608 14.9952 15.6343C15.0021 15.4484 15.0974 15.2764 15.2585 15.1833C15.4196 15.0903 15.6164 15.0938 15.7808 15.1807C15.8927 15.2399 15.9739 15.2727 16.0539 15.2833C16.2292 15.3064 16.4065 15.2588 16.5467 15.1512C16.652 15.0705 16.7296 14.936 16.8849 14.667C17.0402 14.398 17.1179 14.2635 17.1352 14.132C17.1583 13.9567 17.1108 13.7794 17.0031 13.6391C16.954 13.5751 16.885 13.5213 16.7778 13.4539C16.6203 13.3549 16.5189 13.1863 16.5189 13.0003C16.5189 12.8143 16.6203 12.6457 16.7778 12.5467C16.885 12.4794 16.954 12.4255 17.0032 12.3615C17.1108 12.2212 17.1583 12.0439 17.1352 11.8686C17.1179 11.7372 17.0403 11.6027 16.885 11.3337C16.7296 11.0646 16.652 10.9301 16.5468 10.8494C16.4065 10.7418 16.2292 10.6943 16.0539 10.7174C15.9739 10.7279 15.8928 10.7608 15.7809 10.8199C15.6164 10.9069 15.4197 10.9103 15.2586 10.8173C15.0975 10.7243 15.0021 10.5522 14.9952 10.3663C14.9904 10.2398 14.9783 10.1531 14.9475 10.0785C14.8798 9.91518 14.75 9.7854 14.5867 9.71774Z" stroke="#002449"/>
</g>
<defs>
<clipPath id="clip0_5244_39975">
<rect x="10" y="9" width="8" height="8" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>

					</button>

				</Space>
				</div>
			),
		},

	];

	const getRowClassName = (record, index) => {
		return index % 2 === 0 ? "odd-row" : "even-row";
	};

	useEffect(() => {
		const uniqueResults = filterUniqueScans(decodedResults);

		if (uniqueResults.length > 0 && activeScanner) {
			setActiveScanner(null);
			setDecodedResults([]);
		}
	}, [decodedResults, activeScanner]);

	const handleTableChange = (newPagination, filters, sorter) => {
		const normalizeFilters = {};
		Object.keys(filters).forEach((key) => {
			if (filters[key] && filters[key].length > 0) {
				normalizeFilters[key] = filters[key][0];
			}
		});

		setsearchFilters(normalizeFilters);
		setSortedInfo(sorter);

		setPagination(prev => ({
			...prev,
			current: newPagination.current,
			pageSize: newPagination.pageSize,
		}));

		fetchData({
			pagination: { current: newPagination.current, pageSize: newPagination.pageSize },
			sorter,
			filters: normalizeFilters,
		});
	};

	const handleRecycleTableChange = (newPagination, filters, sorter) => {
		const normalizeFilters = {};
		Object.keys(filters).forEach((key) => {
			if (filters[key] && filters[key].length > 0) {
				normalizeFilters[key] = filters[key][0];
			}
		});

		setsearchFilters(normalizeFilters);
		setSortedInfo(sorter);

		// Keep pagination fully controlled
		setPaginationRecycle(prev => ({
			...prev,
			current: newPagination.current, 
			pageSize: newPagination.pageSize,
		}));

		// Fetch using the new pagination
		fetchReCycleData({
			pagination: { current: newPagination.current, pageSize: newPagination.pageSize },
			sorter,
			filters: normalizeFilters,
		});
	};


	const fetchData = async ({ pagination: pag, filters, sorter }) => {

		const payload = {
			pageNo: pag?.current,
			pageSize: pag?.pageSize || 10,
			search: JSON.stringify(filters),
			orderByColumn: sorter?.field || "CreatedOn",
			orderBy: sorter?.order === "ascend" ? "ASC" : "DESC",
		};
		setLoading(true);
		try {
			const myHeaders = {
				"Content-Type": "application/json",
				"Authorization": `Bearer ${accessToken}`,
				"X-CSRF-Token": encryptTimestamp(),
			};
			const response = await fetch(CommonObj.Endpoints.GetClientQueueBookDetails, {
				method: "POST",
				headers: myHeaders,
				body: JSON.stringify(payload),
			});

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
			const responseText = await response.text();
			let result;

			// Try to parse the response as JSON.
			try {
				result = JSON.parse(responseText);
			} catch (e) {
				if (responseText.includes("No books found.")) {
					result = [];
				} else {
					throw new Error(responseText || 'Failed to parse API response.');
				}
			}
			const books = Array.isArray(result) ? result : [result];
			const formattedData = books.map((item) => ({
				...item,
				key: item.referenceId,
			}));
			setData(formattedData);
			const total = formattedData[0]?.totalRows || 0;
			setPagination(prev => ({
				...prev,
				current: pag?.current || prev.current,
				pageSize: pag?.pageSize || prev.pageSize,
				total,
			}));

			const startUTCTime = getUTCDate();
			setStartTime(startUTCTime?.UTCDate);
		} catch (err) {
			setError(err);
		} finally {
			setLoading(false);
		}
	};


	//RecycleDownload
	const [DownloadreCycle, setDownloadreCycle] = useState([]);
	const [totalRowRecycle, setTotalRowRecycle] = useState(1);
	const [paginationRecycle, setPaginationRecycle] = useState({ current: 1, pageSize: 10, total: 0 });
	const [startTimeRecycle, setStartTimeRecycle] = useState("");
	const [allbidRecycle, setAllbidRecycle] = useState("");
	const columnsDownload = [
		{
			title: "BID No",
			dataIndex: "bid",
			key: "bid",
			width: 160,
			/*sorter: (a, b) => a.bid.localeCompare(b.bid),
			...getColumnSearchProps("bid"),*/

		},
		{
			title: "ISBN",
			dataIndex: "isbn",
			key: "isbn",
			width: 200,
			/*sorter: (a, b) => a.isbn.localeCompare(b.isbn),
			...getColumnSearchProps("isbn"),*/
		},
		{
			title: "Title",
			dataIndex: "title",
			key: "title",
			width: 220,
			/*sorter: (a, b) => a.title.localeCompare(b.title),
			...getColumnSearchProps("title"),*/
		},
		{
			title: "Rack Shelf ",
			dataIndex: "rackShelf",
			key: "rackShelf",
			width: 220,
			/*sorter: (a, b) => a.title.localeCompare(b.title),
			...getColumnSearchProps("title"),*/
		},
		{
			title: "Weight(lbs)",
			dataIndex: "weight",
			key: "weight",
			width: 110,
			/*sorter: (a, b) => a.title.localeCompare(b.weight),
			...getColumnSearchProps("weight"),*/
		},
	];

	const prepareDownloadAll = async () => {
		const payload = {
			pageNo: 0,
			pageSize: 0,
			search: "{}",
			orderByColumn: "CreatedOn",
			orderBy: "DESC",
		};

		try {
			const myHeaders = {
				"Content-Type": "application/json",
				"Authorization": `Bearer ${accessToken}`,
				"X-CSRF-Token": encryptTimestamp(),
			};
			const response = await fetch(CommonObj.Endpoints.GetRecycleManifestDownload, {
				method: "POST",
				headers: myHeaders,
				body: JSON.stringify(payload),
			});

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
			const responseText = await response.text();
			let result;

			// Try to parse the response as JSON.
			try {
				result = JSON.parse(responseText);
			} catch (e) {
				if (responseText.includes("No books found.")) {
					result = [];
				} else {
					throw new Error(responseText || 'Failed to parse API response.');
				}
			}
			const books = Array.isArray(result) ? result : [result];
			const formattedData = books.map((item) => ({
				...item,
				key: item.referenceId,
			}));

			const allBID = books.map(data => data.bid).join(",");
			setAllbidRecycle(allBID);
			setDownloadreCycle(formattedData);
		} catch (err) {
			setError(err);
		}
	};

	const sendDownloadAllstatus = async () => {
		const payload = {
			bids: allbidRecycle,
			userId: roleUserId,
		};

		try {
			const myHeaders = {
				"Content-Type": "application/json",
				"Authorization": `Bearer ${accessToken}`,
				"X-CSRF-Token": encryptTimestamp(),
			};
			const response = await fetch(CommonObj.Endpoints.UpdateRecycleManifestStatus, {
				method: "POST",
				headers: myHeaders,
				body: JSON.stringify(payload),
			});

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
		} catch (err) {
			setError(err);
		}
	};

	const handleDownload = async () => {

		setIsDisabled(true); // Disable the button immediately

		setTimeout(() => {
			setIsDisabled(false);
		}, 3000); // 3000 milliseconds = 3 seconds

		try {
			// Fetch data from your API

			if (DownloadreCycle.length === 0) {
				message.error('No record found');
				return;
			}
			// Create PDF document
			const doc = new jsPDF("p", "pt", "a4");

			// Title
			doc.setFont("helvetica", "bold");
			doc.setFontSize(16);
			doc.text("Recycle Manifest", 40, 40);
			// Prepare columns and rows
			const columns = [
				{ header: "BID No", dataKey: "bid" },
				{ header: "ISBN", dataKey: "isbn" },
				{ header: "Title", dataKey: "title" },
				{ header: "Weight(lbs)", dataKey: "weight" },
				{ header: "Rack Shelf", dataKey: "rackShelf" },
			];
			const rows = DownloadreCycle.map((data) => ({
				bid: data.bid,
				isbn: data.isbn,
				title: data.title,
				weight: data.weight,
				rackShelf: data.rackShelf
			}));

			// Add styled table
			autoTable(doc, {
				columns,
				body: rows,
				startY: 60,
				theme: "grid", // grid | strip | plain
				headStyles: {
					fillColor: [41, 128, 185], // Blue header
					textColor: [255, 255, 255],
					fontStyle: "bold",
					halign: "left",
				},
				bodyStyles: {
					textColor: [0, 0, 0],
					lineColor: [200, 200, 200],
					lineWidth: 0.2,
				},
				alternateRowStyles: {
					fillColor: [240, 240, 240], // Light gray background for alternate rows
				},
				columnStyles: {
					bid: { halign: "left", cellWidth: 130 },
					isbn: { cellWidth: 130 },
					title: { halign: "left" },
					weight: { cellWidth: 100 }
				}
			});

			// Save the file
			doc.save("Recycle_Mainfest.pdf");

			// Status change API
			sendDownloadAllstatus();
			setIsModalBoxVisible(false);
		} catch (error) {
			console.error("PDF Generation Failed:", error);
			message.error("PDF Generation Failed:", error);
		}
	};

	const [reCycleManifest, setreCycleManifest] = useState([]);
	const fetchReCycleData = async ({ pagination: pag, filters, sorter }) => {

		const payload = {
			pageNo: pag?.current,
			pageSize: pag?.pageSize || 10,
			search: JSON.stringify(filters),
			orderByColumn: sorter?.field || "CreatedOn",
			orderBy: sorter?.order === "ascend" ? "ASC" : "DESC",
		};
		try {
			const myHeaders = {
				"Content-Type": "application/json",
				"Authorization": `Bearer ${accessToken}`,
				"X-CSRF-Token": encryptTimestamp(),
			};
			const response = await fetch(CommonObj.Endpoints.GetRecycleManifestDownload, {
				method: "POST",
				headers: myHeaders,
				body: JSON.stringify(payload),
			});

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
			const responseText = await response.text();
			let result;

			// Try to parse the response as JSON.
			try {
				result = JSON.parse(responseText);
			} catch (e) {
				if (responseText.includes("No books found.")) {
					result = [];
				} else {
					throw new Error(responseText || 'Failed to parse API response.');
				}
			}
			const books = Array.isArray(result) ? result : [result];
			const formattedData = books.map((item) => ({
				...item,
				key: item.referenceId,
			}));
			setreCycleManifest(formattedData);
			const total = formattedData[0]?.totalRows || 0;
			setTotalRowRecycle(total);
			setPaginationRecycle(prev => ({
				...prev,
				current: pag?.current || prev.current,
				pageSize: pag?.pageSize || prev.pageSize,
				total,
			}));

			const startUTCTime = getUTCDate();
			setStartTimeRecycle(startUTCTime?.UTCDate);
		} catch (err) {
			setError(err);
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		fetchData({ pagination, sorter: sortedInfo, filters: searchFilters });
		setStartTime("");
		setStartTimeRecycle("");

	}, []);

	useEffect(() => {
		if (isModalBoxVisible) {
			fetchReCycleData({ pagination, sorter: sortedInfo, filters: searchFilters });
			prepareDownloadAll();
		}

	}, [isModalBoxVisible]);

	if (loading) {
		return (
			<Spin size="large" style={{ margin: "20px auto" }} />
		);
	}
	function filterUniqueScans(results) {
		const filteredResults = [];
		if (results.length === 0) {
			return filteredResults;
		}
		filteredResults.push(results[0]);
		for (let i = 1; i < results.length; ++i) {
			if (results[i].decodedText !== results[i - 1].decodedText) {
				filteredResults.push(results[i]);
			}
		}
		return filteredResults;
	}

	return (
		<>
			<div className="active-page-container">
				<div className="active-page-header-container">
					<div className="active-page-header-title-container">
						<h4>Client Rejected Queue</h4>
					</div>
				</div>
				<div className="active-page-body-container">
					<Table
						rowSelection={false}
						rowKey="bid"
						columns={columns}
						dataSource={data}
						className="common-pagination common-grid"
						pagination={{
							...pagination,
							pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
							showSizeChanger: true,
							position: ["bottomRight"],
							//total: totalRow,
							defaultPageSize: 10,
							showTotal: (total, range) =>
								renderCommonPaginationTotal(total, range, {
									pagination,
									handleTableChange,
									searchFilters,
									sortedInfo
								}),
						}}
						scroll={{ x: "max-content", y: "calc(100vh - 280px)" }}
						rowClassName={getRowClassName}
						onChange={handleTableChange}
					/>
				</div>
				<div className="active-page-footer-container">
					<div className="active-page-action-container alignbuttons-right">
						<div className="active-page-buttons-container">

						</div>
					</div>
				</div>
			</div>

			{/** Reject Model */}
			<RejectSlide isModalVisible={isModalVisible} accessToken={accessToken} rackId={rackId} rejectionOptions={rejectionOptions} handleCancel={handleCancel} selectedRowKeys={selectedRowKeys} handleClientQueueReject={handleClientQueueReject}  onScannerOpen={(scanner) => { setActiveScanner(scanner) }}
                    emptyDecode={() => { setDecodedResults([]) }} className="story-slider slider-with-footer" isDisabled={isDisabled} width={540} />

						<Modal
				title={`Recycle Manifest`}
				open={isModalBoxVisible}
				onCancel={handleCancel}
				onClose={handleCancel}
				footer={null} // Remove default footer to use form's submit button
				closeIcon={<CloseCircleOutlined />}
				className="recycle-manifest-model"
				width={760}
			>
				<div className="active-page-body-container">
					<div className="rounded-table-wrapper">
						<Table
							columns={columnsDownload}
							dataSource={reCycleManifest}
							className="common-pagination common-grid"
							pagination={{
								...paginationRecycle,
								pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
								showSizeChanger: true,
								position: ["bottomRight"],
								total: totalRowRecycle,
								defaultPageSize: 10,
								showTotal: (total, range) =>
									renderCommonPaginationTotal(total, range, {
										pagination,
										handleTableChange,
										searchFilters,
										sortedInfo
									}),
							}}
							scroll={{ x: "max-content", y: "calc(100vh - 280px)" }}
							rowClassName={getRowClassName}
							onChange={handleRecycleTableChange}
						/>
					</div>
				</div>

				<div className="recycle-model-footer-container">
					<Space>
						<button disabled={isDisabled} className="submit-button-gradiant-outline-fill" type="submit" onClick={handleDownload}>
							<span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clipPath="url(#clip0_2848_31904)">
									<path d="M4.9396 9.061C5.0789 9.20039 5.2443 9.31097 5.42635 9.38641C5.6084 9.46185 5.80354 9.50068 6.0006 9.50068C6.19766 9.50068 6.3928 9.46185 6.57485 9.38641C6.7569 9.31097 6.9223 9.20039 7.0616 9.061L8.6671 7.4555C8.75318 7.3603 8.79935 7.23564 8.79606 7.10733C8.79277 6.97902 8.74026 6.8569 8.6494 6.76624C8.55855 6.67558 8.43631 6.62333 8.308 6.6203C8.17968 6.61728 8.05512 6.66372 7.9601 6.75L6.4971 8.2135L6.5006 0.5C6.5006 0.367392 6.44792 0.240215 6.35415 0.146447C6.26039 0.0526784 6.13321 0 6.0006 0C5.86799 0 5.74082 0.0526784 5.64705 0.146447C5.55328 0.240215 5.5006 0.367392 5.5006 0.5L5.4961 8.204L4.0411 6.75C3.94728 6.65625 3.82006 6.6036 3.68742 6.60365C3.55479 6.6037 3.42761 6.65643 3.33385 6.75025C3.2401 6.84407 3.18745 6.97129 3.1875 7.10393C3.18755 7.23656 3.24028 7.36375 3.3341 7.4575L4.9396 9.061Z" fill="url(#paint0_linear_2848_31904)" />
									<path d="M11.5 8C11.3674 8 11.2402 8.05268 11.1464 8.14645C11.0527 8.24021 11 8.36739 11 8.5V10.5C11 10.6326 10.9473 10.7598 10.8536 10.8536C10.7598 10.9473 10.6326 11 10.5 11H1.5C1.36739 11 1.24021 10.9473 1.14645 10.8536C1.05268 10.7598 1 10.6326 1 10.5V8.5C1 8.36739 0.947322 8.24021 0.853553 8.14645C0.759785 8.05268 0.632608 8 0.5 8C0.367392 8 0.240215 8.05268 0.146447 8.14645C0.0526784 8.24021 0 8.36739 0 8.5L0 10.5C0 10.8978 0.158035 11.2794 0.43934 11.5607C0.720644 11.842 1.10218 12 1.5 12H10.5C10.8978 12 11.2794 11.842 11.5607 11.5607C11.842 11.2794 12 10.8978 12 10.5V8.5C12 8.36739 11.9473 8.24021 11.8536 8.14645C11.7598 8.05268 11.6326 8 11.5 8Z" fill="url(#paint1_linear_2848_31904)" />
								</g>
								<defs>
									<linearGradient id="paint0_linear_2848_31904" x1="8.96449" y1="4.7241" x2="3.12737" y2="5.08207" gradientUnits="userSpaceOnUse">
										<stop stopColor="var(--color-1)" />
										<stop offset="1" stopColor="var(--color-2)" />
									</linearGradient>
									<linearGradient id="paint1_linear_2848_31904" x1="12.36" y1="9.98895" x2="0.93409" y2="13.5498" gradientUnits="userSpaceOnUse">
										<stop stopColor="var(--color-2)" />
										<stop offset="1" stopColor="var(--color-1)" />
									</linearGradient>
									<clipPath id="clip0_2848_31904">
										<rect width="12" height="12" fill="white" />
									</clipPath>
								</defs>
							</svg>
							</span>
							<span>Download</span>
						</button>
						<button
							className="accept-button"
							type="button"
							onClick={handleCancel}
						>
							Close <span><svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M10.9126 6.99629L7.6614 3.74504C7.52868 3.61311 7.34916 3.53906 7.16202 3.53906C6.97489 3.53906 6.79536 3.61311 6.66265 3.74504C6.59626 3.81089 6.54356 3.88923 6.5076 3.97555C6.47164 4.06187 6.45312 4.15445 6.45312 4.24796C6.45312 4.34147 6.47164 4.43405 6.5076 4.52037C6.54356 4.60668 6.59626 4.68503 6.66265 4.75087L9.92098 7.99504C9.98737 8.06089 10.0401 8.13923 10.076 8.22555C10.112 8.31187 10.1305 8.40445 10.1305 8.49796C10.1305 8.59147 10.112 8.68405 10.076 8.77037C10.0401 8.85668 9.98737 8.93502 9.92098 9.00087L6.66265 12.245C6.52927 12.3775 6.45396 12.5575 6.4533 12.7455C6.45263 12.9334 6.52667 13.1139 6.65911 13.2473C6.79155 13.3807 6.97155 13.456 7.15952 13.4567C7.34749 13.4573 7.52802 13.3833 7.6614 13.2509L10.9126 9.99962C11.3106 9.60119 11.5341 9.06108 11.5341 8.49796C11.5341 7.93483 11.3106 7.39473 10.9126 6.99629Z" fill="white" />
							</svg>
							</span>
						</button>
					</Space>
				</div>

			</Modal>
		</>
	);
};
export default Clientqueue;